import React from 'react';
import {withStyles} from 'material-ui/styles';
import {
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';
import Tooltip from 'material-ui/Tooltip';
import {translate} from 'react-i18next';

const styles = theme => ({
});

class SpecialDestionationTableHead extends React.Component {

    constructor(props){
        super(props);

        const { t } = props;

        this.state = {
            columnData : [
                { 
                    id: 'name', 
                    paddingLeft: '10px', 
                    numeric: false, 
                    disablePadding: false, 
                    label: t('SPECIAL_DESTINATION.NAME') 
                },
                { 
                    id: 'actions', 
                    numeric: false, 
                    disablePadding: false, 
                    width: '32px',
                    label: t('SPECIAL_DESTINATION.ACTIONS')
                }
            ]
        };
    }

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, t } = this.props;
        return (
            <TableHead>
                <TableRow>
                    {this.state.columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                width={column.width}
                                style={{ 
                                    width: column.width, 
                                    backgroundColor: 'lightgrey', 
                                    paddingLeft: column.paddingLeft 
                                }}
                                padding={'none'}
                                sortDirection={orderBy === column.id ? order : false}
                            >
                                <Tooltip
                                    title={t('SPECIAL_DESTINATION.SORT')}
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

export default translate('translations')(withStyles(styles)(SpecialDestionationTableHead));


// WEBPACK FOOTER //
// ./src/components/SpecialDestinations/Table/SpecialDestinationTableHeader.js